import { toast } from "react-hot-toast";
import { TOAST_MESSAGES } from "@/lang/toast-messages.lang";

/**
 * Displays a toast message and redirects the user after a specified timeout.
 *
 * @param type - The type of toast message (e.g., 'success', 'error', 'loading').
 * @param toastMsg - The key of the toast message to be displayed from TOAST_MESSAGES.
 * @param toastDuration - The duration in milliseconds for the toast to be visible.
 * @param redirectTimeout - The timeout in milliseconds before redirecting the user.
 * @param url - The URL to which the user should be redirected.
 * @param id - The ID to assign to the toast message for identification.
 */
export function toastAndRedirect(
    type: "success" | "error" | "loading",
    toastMsg: string,
    toastDuration: number = 1000,
    redirectTimeout: number = 2000,
    url: string = "/",
    id: string = "toast-and-redirect",
): void {
    // Try to parse the toast message error path if possible
    const message = toastMsg
        .split(".")
        .reduce((prev: any, curr: string) => (prev ? prev[curr] : undefined), TOAST_MESSAGES);

    toast[type](message ?? "An error occurred.", {
        id,
        duration: toastDuration,
        style: { padding: "5px" },
    });

    // Redirect after timeout
    setTimeout(() => {
        window.location.href = url;
    }, redirectTimeout);
}
